const HARM_WATCH_FEED_1 = {
  isTranslated: false,
  relevance: true,
  postId: '355665009819_780674434108611',
  feedImage: "https://scontent.fsin15-1.fna.fbcdn.net/v/t39.30808-6/431017984_780657284110326_2243443389793231779_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=5f2048&_nc_ohc=Qq1i84pC6i4AX9vOcIx&_nc_ht=scontent.fsin15-1.fna&oh=00_AfDBnZaZfWaYqIuWlBukeW8eNTXGrb4OY3K_Sl14VN2rjQ&oe=65F53A89",
  feedLink: "https://www.facebook.com/628101419365914/posts/780674434108611",
  feedMessage: "Misty on Tai Mo Shan ⛰️\n\nA lone hiker in traditional clothing is surrounded by almost magical scenery on Hong Kong's highest peak at Tai Mo Shan on March 3, 2024 as a thick fog enveloped the city.\n\nThe Observatory said a relatively humid airstream would affect the coast of Guangdong over the coming days, bringing more humidity, rain and mist.\n\nTemperatures could reach 25 degrees Celsius on March 5, before a northeast monsoon later in the week brings cooler weather and windy conditions.\n\n📷️: Dickson Lee",
  feedTitle: "Photos from South China Morning Post's post",
  feedDescription: "",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 1:34 PM",
  source: "south china morning post (facebook page)",
  isCharged: true,
  hasEmotionallyHeatedComments: true,
  isNonFactual: true,
  isHateful: true,
};

const HARM_WATCH_FEED_2 = {
  isTranslated: false,
  relevance: true,
  postId: '1042446452442226_957838632373098',
  feedImage: "https://scontent.fsin15-1.fna.fbcdn.net/v/t39.30808-6/429534378_957838649039763_2838310186381978955_n.jpg?stp=dst-jpg_p843x403&_nc_cat=101&ccb=1-7&_nc_sid=5f2048&_nc_ohc=zCKi3WzG0MAAX-dRbRD&_nc_ht=scontent.fsin15-1.fna&oh=00_AfC34p4XSskPIyigh_HYxqpOxk12RDO6aIxgqxL4x3ZF3g&oe=65F839EB",
  feedLink: "https://www.facebook.com/432895481534085/posts/957838632373098",
  feedMessage: "A female house owner staying in angmoh chu (landed house) was unhappy that a car owner always anyhow park his/her car in front of her house, blocking her gate, she then left a note in anger for the car owner and took a photo of the car and posted it online to shame them.\n" +
    "\n" +
    "She argues that if she got emergency and she needs to call an ambulance for her mother, the ambulance would be blocked by the car.\n" +
    "\n" +
    "On 25 February, a 44-year-old woman who lives in Penshurst Place in Serangoon, took to the Facebook page \"Complaint Singapore\" to share how a car owner who had illegally parked in front of her house had caused much inconvenience to her.\n" +
    "\n" +
    "In the post, the OP stated that the driver parked his/her car in front of her house from 12pm onwards and only left after more than an hour.\n" +
    "\n" +
    "The OP also shared a picture of a note she placed on the windshield of the car, telling the car owner that she has an elderly mother at home and therefore hopes that the driver will not park the car in front of her gate, otherwise in the event of an emergency, the driver’s action may cause inconvenience to her and her family.\n" +
    "\n" +
    "The OP also replied to a few netizens in the post and according to her understanding, the driver was the owner of a nearby clinic. She did not want to sour the relationship between them, so she placed the note and would not report it to the authorities.\n" +
    "\n" +
    "\"I'm not stopping drivers from parking on the pavement, but please do not park directly in front of someone's house because that would bring us inconvenience,\" she said.\n" +
    "\n" +
    "The OP also added that the car owner would park his/her vehicle in front of her gate at least twice a month in the past few years. To prevent him/her from doing so, she and her neighbors would place rubbish bins but that did not help.\n" +
    "\n" +
    "“We tried placing rubbish bins, but the car owner would still find another angle and park in front of the gate. If he/she continues to do this, I will contact the authorities or the towing company directly,” she said.",
  feedTitle: "",
  feedDescription: "A female house owner staying in angmoh chu (landed house) was unhappy that a car owner always anyhow park his/her car in front of her house, blocking her gate, she then left a note in anger for the car owner and took a photo of the car and posted it online to shame them.\n" +
    "\n" +
    "She argues that if she got emergency and she needs to call an ambulance for her mother, the ambulance would be blocked by the car.\n" +
    "\n" +
    "On 25 February, a 44-year-old woman who lives in Penshurst Place in Serangoon, took to the Facebook page \"Complaint Singapore\" to share how a car owner who had illegally parked in front of her house had caused much inconvenience to her.\n" +
    "\n" +
    "In the post, the OP stated that the driver parked his/her car in front of her house from 12pm onwards and only left after more than an hour.\n" +
    "\n" +
    "The OP also shared a picture of a note she placed on the windshield of the car, telling the car owner that she has an elderly mother at home and therefore hopes that the driver will not park the car in front of her gate, otherwise in the event of an emergency, the driver’s action may cause inconvenience to her and her family.\n" +
    "\n" +
    "The OP also replied to a few netizens in the post and according to her understanding, the driver was the owner of a nearby clinic. She did not want to sour the relationship between them, so she placed the note and would not report it to the authorities.\n" +
    "\n" +
    "\"I'm not stopping drivers from parking on the pavement, but please do not park directly in front of someone's house because that would bring us inconvenience,\" she said.\n" +
    "\n" +
    "The OP also added that the car owner would park his/her vehicle in front of her gate at least twice a month in the past few years. To prevent him/her from doing so, she and her neighbors would place rubbish bins but that did not help.\n" +
    "\n" +
    "“We tried placing rubbish bins, but the car owner would still find another angle and park in front of the gate. If he/she continues to do this, I will contact the authorities or the towing company directly,” she said.",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 4:55 PM",
  source: "sureboh.sg (facebook page)",
  isCharged: false,
  hasEmotionallyHeatedComments: true,
  isNonFactual: false,
  isHateful: true,
};

const HARM_WATCH_FEED_3 = {
  isTranslated: true,
  relevance: true,
  postId: '357787027613216_789781963175555',
  feedImage: "https://scontent.fsin15-2.fna.fbcdn.net/v/t39.30808-6/429782770_789740339846384_1144414703666500290_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=5f2048&_nc_ohc=K_dVycB2RS0AX_J0xr8&_nc_ht=scontent.fsin15-2.fna&oh=00_AfDEv3yA-ZZWe4T_eMGqVPF7FKEEdb2CGDtvDx0QVvKfOg&oe=65F4EF4E",
  feedLink: "https://www.facebook.com/633686215451798/posts/789781963175555",
  feedMessage: "[Malaysia] Deities of ancient Johor temples greet each other \n" +
    " \n" +
    "Following the lighting ceremony and the street washing ceremony, the procession of the deities of the ancient temple of Johor was held at 11:00am today (the 20th day of the first month of the lunar month). Five deities smoothly defied the emperor and the scene was full of excitement. Tomorrow night (the 21st day of the first month of the lunar month) will be the climax of the procession of the deities of the ancient temple of Johor. \n" +
    "At about 8.30am this morning, many worshippers had already arrived at the old Johor temple to pay their respects. The crowd was heavy, and at 11:00am, surrounded by members of the security team, the five deities of the old Johor temple set out from the old temple in Johor to visit the old Johor temple walking on Yixing Road, a few kilometres away. \n" +
    "Tens of thousands of \"happy!\" \"go on!\" the sound, once again, reverberated through the heart of Johor Bahru.     \n" +
    "According to China Daily, despite the scorching sun, many people, including the elderly and the young, came to the old temple to pay their respects to the five deities. \n" +
    "It is worth mentioning that this year, Johor regent Tunku Ismai and Chinese ambassador Ouyang Yujing will be invited to attend the night tour of the Gods tomorrow night. (Article and Photo: China News)   \n" +
    " \n" +
    "(For news, please call 91918727.) gift vouchers of up to $50!)",
  feedTitle: "Photos from Shin Min Daily News Shin Min Daily News",
  feedDescription: "",
  feedMessageInOriginalLanguage: "【马国】柔佛古庙众神出銮　善信夹道恭迎\n" +
    "\n" +
    "　　继亮灯仪式和洗街仪式之后，柔佛古庙众神巡遊活动今日（农历正月廿日）上午11时吉时，迎来了五尊神明顺利出銮，场面热闹非凡，再现万人空巷，明晚（农历正月廿一）将是柔佛古庙众神圣驾巡游的高潮。\n" +
    "　　今早约8时30分，许多善信已抵达柔佛古庙参拜，人潮汹涌，上午11时吉时一到，在护轿组人员簇拥下，柔佛古庙五大神明乘坐圣驾依序出銮，从柔佛古庙出发，前往数公里外的义兴路柔佛古庙行宫。\n" +
    "　　数以万计沿途“兴啊！”、“发啊！”声浪，再次响彻新山市中心。\n" +
    "　　据《中国报》报道，尽管烈日高空，当中有不少民众扶老携幼，前来古庙恭送五尊神明。\n" +
    "　　值得一提的是，今年柔佛摄政王东姑依斯迈、中国大使欧阳玉靖将应邀出席明晚的众神夜游活动。（文与图：中国报）\n" +
    "\n" +
    "　　（有新闻，请拨 91918727。送最高$50礼券！）",
  feedTitleInOriginalLanguage: "Photos from Shin Min Daily News 新明日报's post",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-02-29 3:45 PM",
  source: "shin min daily news",
  icon: "facebook",
  isCharged: true,
  hasEmotionallyHeatedComments: false,
  isNonFactual: true,
  isHateful: false,
};

const HARM_WATCH_FEED_4 = {
  isTranslated: false,
  relevance: true,
  postId: '121790674546188_802299605255860',
  feedImage: "https://scontent.fsin15-1.fna.fbcdn.net/v/t39.30808-6/431561348_802299578589196_122462074312607098_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=5f2048&_nc_ohc=HDq0w3BOwfQAX92T3Lt&_nc_ht=scontent.fsin15-1.fna&oh=00_AfDrLG4Djd8F_rRc7coG6aDCpjURJZqz9inzBN20AJ2pXQ&oe=65F82102",
  feedLink: "https://www.facebook.com/665257205626768/posts/802299605255860",
  feedMessage: "In today's COS debates, Minister of Manpower, Dr Tan See Leng shared how every older Singaporean will benefit from a comprehensive suite of retirement adequacy measures.",
  feedTitle: "",
  feedDescription: "In today's COS debates, Minister of Manpower, Dr Tan See Leng shared how every older Singaporean will benefit from a comprehensive suite of retirement adequacy measures.",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 4:18 PM",
  source: "sureboh.sg (facebook page)",
  isCharged: true,
  hasEmotionallyHeatedComments: false,
  isNonFactual: false,
  isHateful: false,
};

const HARM_WATCH_FEED_5 = {
  isTranslated: false,
  relevance: true,
  postId: '121790674546188_802311648587989',
  feedImage: "https://scontent.fsin15-2.fna.fbcdn.net/v/t39.30808-6/431486186_802311548587999_8201690739588224062_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=5f2048&_nc_ohc=ypfWJef_YrgAX9DfMxh&_nc_ht=scontent.fsin15-2.fna&oh=00_AfALWlFUZsV8Stv2FIH0JzXq2Wki4RJmZm0XNNii1AUCBQ&oe=65F6530F",
  feedLink: "https://www.facebook.com/665257205626768/posts/802311648587989",
  feedMessage: "As outlined by Senior Minister of State for Manpower, Zaqy Mohamad, uplifting lower-wage workers is a whole-of-society effort.\n" +
    "\n" +
    "The government is working hand-in-hand with employers, service buyers, consumers and workers, to progress together and ensure no worker is left behind.",
  feedTitle: "Photos from AsiaOne's post",
  feedDescription: "",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 4:18 PM",
  source: "asiaone (facebook page)",
  icon: 'facebook',
  isCharged: false,
  hasEmotionallyHeatedComments: false,
  isNonFactual: true,
  isHateful: true,
};

const HARM_WATCH_FEED_6 = {
  isTranslated: false,
  relevance: true,
  postId: '129011692114_709963381290825',
  feedImage: "https://scontent.fsin15-2.fna.fbcdn.net/v/t39.30808-6/429786482_709963364624160_6203222111350165488_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=5f2048&_nc_ohc=4wOUu4PXhWAAX-5H9a-&_nc_ht=scontent.fsin15-2.fna&oh=00_AfBnchR_IryQU_TnR8cwIIf3dYXwPMD6j9eWWZiOwZ42zg&oe=65F4016C",
  feedLink: "https://www.facebook.com/565216395765525/posts/709963381290825",
  feedMessage: "New EP applicants will have to earn more to qualify for the pass from Jan 1 next year. The criteria will kick in from Jan 1, 2026, for renewals. https://str.sg/8Bk6",
  feedTitle: "",
  feedDescription: "New EP applicants will have to earn more to qualify for the pass from Jan 1 next year. The criteria will kick in from Jan 1, 2026, for renewals. https://str.sg/8Bk6",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 3:57 PM",
  source: "the straits times (facebook page)",
  isCharged: true,
  hasEmotionallyHeatedComments: true,
  isNonFactual: false,
  isHateful: true,
};

const HARM_WATCH_FEED_7 = {
  isTranslated: false,
  relevance: true,
  postId: '1042446452442226_957764209047207',
  feedImage: "https://scontent.fsin15-2.fna.fbcdn.net/v/t39.30808-6/429560787_957764222380539_942812508601436830_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=5f2048&_nc_ohc=BmUyH9io8hQAX8ZxR8S&_nc_ht=scontent.fsin15-2.fna&oh=00_AfAkRf40U3ig0yIT7WFpFskWsGd17KXB9hj_eprzK7jFvg&oe=65F54DB5",
  feedLink: "https://www.facebook.com/432895481534085/posts/957764209047207",
  feedMessage: "Can is can lah. Just that means, no malatang, no bubble tea... can only eat Cai Png at Rice Garden lor. And tia gong if you flash your NTUC member card, you still get to enjoy 2 selected vegetables and 1 selected meat at cheaper price. Pioneer Generation, Merdeka Generation, CHAS Blue card holder also have.",
  feedTitle: "",
  feedDescription: "Can is can lah. Just that means, no malatang, no bubble tea... can only eat Cai Png at Rice Garden lor. And tia gong if you flash your NTUC member card, you still get to enjoy 2 selected vegetables and 1 selected meat at cheaper price. Pioneer Generation, Merdeka Generation, CHAS Blue card holder also have.",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 1:22 PM",
  source: "sureboh.sg (facebook page)",
  isCharged: false,
  hasEmotionallyHeatedComments: true,
  isNonFactual: false,
  isHateful: false,
};

const HARM_WATCH_FEED_8 = {
  isTranslated: false,
  relevance: true,
  postId: '14440041382_806372418192448',
  feedImage: "https://scontent.fsin15-2.fna.fbcdn.net/v/t39.30808-6/431008376_806370894859267_2052648381699448635_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=5f2048&_nc_ohc=YzaC4tbDdF0AX9g_xpI&_nc_ht=scontent.fsin15-2.fna&oh=00_AfDuIJRTpmjnfztz8drB-LzUDH8VucBsiofoUe9g3cjAnA&oe=65F4AEC9",
  feedLink: "https://www.facebook.com/669221361907555/posts/806372418192448",
  feedMessage: "In light of the forthcoming Qing Ming festival, a significant surge in traffic to the National Environment Agency's (NEA) booking page has led to temporary suspension of access, leaving many in a queue as the agency works to manage the influx. \n" +
    "\n" +
    "https://nea.queue-it.net/\n" +
    "\n" +
    "NEA's website advises patience, stating, \"Due to high traffic, we’re holding you in a queue before we connect you to our website. We’re doing our best to accommodate everyone. If you’re unable to wait, please try again later.\"\n" +
    "\n" +
    "This comes after NEA's announcement that during the Qing Ming festival, Good Friday, and the surrounding weekends from 18 March to 16 April 2023, only vehicles with valid e-appointments will be permitted to enter and park within the premises of government-managed cemetery and columbaria such as Choa Chu Kang Cemetery, Choa Chu Kang Columbarium, Mandai Columbarium, and Yishun Columbarium. \n" +
    "\n" +
    "The measure aims to streamline the anticipated large crowds and ensure a smooth visitation process for everyone involved. Those opting for public transport or private hire vehicles are exempt from this requirement.",
  feedTitle: "",
  feedDescription: "In light of the forthcoming Qing Ming festival, a significant surge in traffic to the National Environment Agency's (NEA) booking page has led to temporary suspension of access, leaving many in a queue as the agency works to manage the influx. \n" +
    "\n" +
    "https://nea.queue-it.net/\n" +
    "\n" +
    "NEA's website advises patience, stating, \"Due to high traffic, we’re holding you in a queue before we connect you to our website. We’re doing our best to accommodate everyone. If you’re unable to wait, please try again later.\"\n" +
    "\n" +
    "This comes after NEA's announcement that during the Qing Ming festival, Good Friday, and the surrounding weekends from 18 March to 16 April 2023, only vehicles with valid e-appointments will be permitted to enter and park within the premises of government-managed cemetery and columbaria such as Choa Chu Kang Cemetery, Choa Chu Kang Columbarium, Mandai Columbarium, and Yishun Columbarium. \n" +
    "\n" +
    "The measure aims to streamline the anticipated large crowds and ensure a smooth visitation process for everyone involved. Those opting for public transport or private hire vehicles are exempt from this requirement.",
  feedMessageInOriginalLanguage: "",
  feedTitleInOriginalLanguage: "",
  feedDescriptionInOriginalLanguage: "",
  feedDateTime: "2024-03-04 11:16 AM",
  source: "the online citizen (facebook page)",
  icon: "facebook",
  isCharged: false,
  hasEmotionallyHeatedComments: false,
  isNonFactual: false,
  isHateful: true,
};

export const HARM_WATCH_FEEDS = [
  HARM_WATCH_FEED_1,
  HARM_WATCH_FEED_2,
  HARM_WATCH_FEED_3,
  HARM_WATCH_FEED_4,
  HARM_WATCH_FEED_5,
  HARM_WATCH_FEED_6,
  HARM_WATCH_FEED_7,
  HARM_WATCH_FEED_8,
];

export const MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT = 150;
export const MAX_HARM_WATCH_FEED_TITLE_LENGTH = 70;
export const NUMBER_OF_COLUMNS_ON_HARM_WATCH_DASHBOARD = 3;

export const HEATED_COMMENTS_PERCENTAGE_THRESHOLD = 50;
export const TOXIC_COMMENTS_PERCENTAGE_THRESHOLD = 10;

export const CHARGED_POST_ICON_TOOLTIP = "Posts that are emotionally charged.";
export const HEATED_COMMENTS_ICON_TOOLTIP = `More than ${String(HEATED_COMMENTS_PERCENTAGE_THRESHOLD)}% of the post comments are heated.`;
export const TOXIC_COMMENTS_ICON_TOOLTIP = `More than ${String(TOXIC_COMMENTS_PERCENTAGE_THRESHOLD)}% of the post comments are toxic.`;

export const CHARGED_POSTS_BUTTON_LABEL = "Charged Posts";
export const HEATED_COMMENTS_BUTTON_LABEL = "Heated Comments";
export const TOXIC_COMMENTS_BUTTON_LABEL = "Toxic Comments";
export const EXPORT_BUTTON_LABEL = "Export";

export const IMAGE_BTN_SELECTED_CLASS = 'image-btn-selected';
export const IMAGE_BTN_UNSELECTED_CLASS = 'image-btn-unselected';

export const FEED_MODAL_PAGE_LIMIT = 10;


// WEBPACK FOOTER //
// ./src/features/harmwatch/constants.js